var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabs = function SvgLabs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "labs_svg__a",
    width: 13,
    height: 13,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h13v13H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#labs_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.708 11.375q-.69 0-.982-.616-.29-.616.143-1.144l3.006-3.657v-3.25h-.542a.52.52 0 0 1-.386-.155.52.52 0 0 1-.156-.386q0-.23.156-.386a.52.52 0 0 1 .386-.156h4.333q.231 0 .386.156a.52.52 0 0 1 .156.386.52.52 0 0 1-.156.386.52.52 0 0 1-.386.155h-.541v3.25l3.006 3.657q.433.528.142 1.144-.29.616-.982.616zM3.791 9.75h5.417L7.366 7.583H5.633zm-1.083.542h7.583l-3.25-3.954v-3.63H5.958v3.63z"
  }))));
};
export default SvgLabs;